import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from '@/plugins/vuetify';
import store from './store';
import './registerServiceWorker';
import { isNavigationFailure } from 'vue-router';

// Vue Router 4 の push()/replace() は NavigationFailure で reject することがある。
// キャッチされなかった場合でも overlay に表示されないよう抑制する。
window.addEventListener('unhandledrejection', (event) => {
  if (isNavigationFailure(event.reason)) {
    event.preventDefault();
  }
});
// fontawesome
import '@fortawesome/fontawesome-free-webfonts/css/fontawesome.css';
import '@fortawesome/fontawesome-free-webfonts/css/fa-brands.css';
import '@fortawesome/fontawesome-free-webfonts/css/fa-regular.css';
import '@fortawesome/fontawesome-free-webfonts/css/fa-solid.css';
import axios from 'axios';

axios.interceptors.response.use((res) => {
    const token = res.headers['x-csrf-token'];
    if (token) {
        axios.defaults.headers.common['X-CSRF-Token'] = token;
    }
    return res;
});

const app = createApp(App);
app.use(router);
app.use(store);
app.use(vuetify);
app.mount('#app');
